function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Text = require("../Text");
var _Button = require("../Button");
var _utils = require("../../utils");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["style", "children", "CategoryPills", "title", "description", "primaryActionLabel", "primaryActionLink", "primaryActionOnPress", "primaryActionTrackingOnPress", "primaryActionFakeButtonLabel", "Image", "isCentred", "SecondaryAction"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Card = exports.Card = (0, _react.memo)(function (_ref) {
  var style = _ref.style,
    children = _ref.children,
    CategoryPills = _ref.CategoryPills,
    title = _ref.title,
    description = _ref.description,
    primaryActionLabel = _ref.primaryActionLabel,
    primaryActionLink = _ref.primaryActionLink,
    primaryActionOnPress = _ref.primaryActionOnPress,
    primaryActionTrackingOnPress = _ref.primaryActionTrackingOnPress,
    primaryActionFakeButtonLabel = _ref.primaryActionFakeButtonLabel,
    Image = _ref.Image,
    isCentred = _ref.isCentred,
    SecondaryAction = _ref.SecondaryAction,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _isPointerOver = _useState2[0],
    _setIsPointerOver = _useState2[1];
  var _useStyles = (0, _styles.useStyles)({
      isCentred: isCentred
    }),
    styles = _useStyles.styles;
  var _opacity = (0, _react.useRef)(new _reactNative.Animated.Value(1)).current;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  var _hasLink = !!primaryActionLabel && (!!primaryActionLink || !!primaryActionOnPress);
  var _hasChildren = !!children;
  var _hasImage = !!Image;
  var _hasButton = !!primaryActionFakeButtonLabel && _hasLink;
  var _isSmall = bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m]) || isCentred;
  var _setOpacity = function _setOpacity(toValue, duration) {
    _reactNative.Animated.timing(_opacity, {
      useNativeDriver: _utils.useNativeDriver,
      toValue: toValue,
      duration: duration,
      easing: _reactNative.Easing.inOut(_reactNative.Easing.quad)
    }).start();
  };
  var _opacityActive = function _opacityActive() {
    _setOpacity(0.6, 150);
  };
  var _opacityInactive = function _opacityInactive() {
    _setOpacity(1, 250);
  };
  var _onPointerEnter = function _onPointerEnter() {
    _setIsPointerOver(true);
  };
  var _onPointerLeave = function _onPointerLeave() {
    _setIsPointerOver(false);
  };
  return (0, _jsxRuntime.jsxs)(_reactNative.Animated.View, Object.assign({
    style: [styles.container, _hasImage && styles.container_image, {
      opacity: _opacity
    }, _isPointerOver && styles.container_pointerOver, style],
    testID: "Card"
  }, props, {
    children: [_hasLink && (0, _jsxRuntime.jsx)(_Button.Button, {
      containerStyle: styles.primaryActionContainer,
      textStyle: styles.primaryActionText,
      label: primaryActionLabel,
      hideLabel: true,
      onPress: primaryActionOnPress,
      onPressIn: _opacityActive,
      onPressOut: _opacityInactive,
      href: primaryActionLink,
      type: _Button.ButtonType.blank,
      onPointerEnter: _onPointerEnter,
      onPointerLeave: _onPointerLeave,
      trackingOnPress: primaryActionTrackingOnPress
    }), _hasImage && !_isSmall && (0, _jsxRuntime.jsx)(Image, {
      style: styles.image,
      testID: "CardImage"
    }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.contentContainer,
      pointerEvents: "box-none",
      children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: [styles.content, _hasButton && styles.content_button],
        pointerEvents: "box-none",
        children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: styles.topActions,
          pointerEvents: "box-none",
          children: [CategoryPills, !_isSmall && SecondaryAction, _hasImage && _isSmall && (0, _jsxRuntime.jsx)(_reactNative.View, {
            children: (0, _jsxRuntime.jsx)(Image, {
              style: styles.image,
              testID: "CardImage"
            })
          })]
        }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
          pointerEvents: "none",
          style: {
            width: '100%'
          },
          children: [(0, _jsxRuntime.jsx)(_Text.Text, {
            containerStyle: styles.titleContainer,
            textStyle: styles.title,
            children: title
          }), description && (0, _jsxRuntime.jsx)(_Text.Text, {
            containerStyle: styles.descriptionContainer,
            textStyle: styles.description,
            children: description
          })]
        })]
      }), _hasButton && (0, _jsxRuntime.jsx)(_Button.Button, {
        label: primaryActionFakeButtonLabel,
        type: _Button.ButtonType.normal,
        isFake: true,
        containerStyle: styles.buttonContainer,
        testID: "PrimaryActionFakeButton"
      })]
    }), _hasChildren && (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.children,
      pointerEvents: "box-none",
      children: children
    }), _isSmall && !!SecondaryAction && (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: styles.secondaryActionContainer,
      pointerEvents: "box-none",
      children: SecondaryAction
    })]
  }));
});